import initDonation from './donation';
import initEventHeader from './event_header';
import initFilterButtons from './filter_buttons';
import { initHeader, initAnchorNav } from './header';
import initPageList from './pages_list';
import initProductItem from './product_item';
import initShowList from './show_list';
import initSoon from './soon';
import initThemeStickyHeader from './theme_sticky_header';
import initVideo from './video';
import { shortcutsMenu } from './shortcuts_menu';


function initParts(): void {
    initDonation();
    initEventHeader();
    initFilterButtons();
    initHeader();
    initAnchorNav();
    initPageList();
    initProductItem();
    initShowList();
    initSoon();
    initThemeStickyHeader();
    initVideo();
    shortcutsMenu.init();
}

export default initParts;
